module.exports = __webpack_public_path__ + "static/media/scholastic-logo-white-outline.9b3c5c62.svg";